<template>
  <FormSelect
    :name="$t('meta.vehicle')"
    @input="$emit('input', $event)"
    :value="value"
    :loading="loading"
    :disabled="disabled"
    :required="required"
    :options="vehicleOptions"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import vehiclesApi from '@/api/vehicles'

export default {
  name: 'VehicleSelect',
  components: { FormSelect },
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    companyUuid: { type: String },
  },
  data: () => ({
    vehicleOptions: null,
    loading: true,
  }),
  watch: {
    companyUuid: {
      async handler() {
        this.loading = true
        this.vehicleOptions = await vehiclesApi.selectableVehicles(this.companyUuid)
        this.loading = false
      },
      immediate: true,
    },
  },
}
</script>
